// takes an array
const setData = (state, data) => {
  state.data = data.screenings || [];
  state.numAvailableAnswers = data.numAvailableAnswers;
  state.numAwaitingResponse = data.numAwaitingResponse;
}

// takes an object
const push = (state, data) => {
  state.data.push(data)
}

export default {
  setData,
  push
}